import { FunctionComponent as F } from "react";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import LinkIcon from '@mui/icons-material/Link';
import TextTooltip from "../UI/Tooltip/TextTooltip";
import { productDesc } from "../../utils/string";


interface IProps
{
  rows: {
    productName: string,
    brandName: string,
    vendorName: string,
    amount: number,
    amountUnit: string,
    quantity?: number,
    url: string }[];
  savingType: string;
}


const CostBreakdownDescr: F<IProps> = (props: IProps) =>
{
  const rows = props.rows;

  return (
    <Stack spacing={0.5} sx={{ width: '100%' }}>
      <Typography variant='body2' style={{ fontSize: 14, fontWeight: 600 }}>
        {"Cost breakdown of " + props.savingType + ": "}
      </Typography>
      {rows.map((row, i) => (
        <Stack key={i} direction={'row'} spacing={0.5} sx={{ width: '100%' }}>
          <Typography variant='body2' style = {{ fontSize: 14 }}>
            {productDesc(row) + " from " + row.vendorName + (((row.quantity || 1) > 1) ? " x " + row.quantity : "")}
          </Typography>
          <TextTooltip lines={[row.url]}>
            <Link
              sx={{ display: 'inline-flex' }}
              target='_blank'
              rel='noreferrer noopener'
              href={row.url}>
              <LinkIcon fontSize='small' sx={{ mb: -1, color: 'lightGray' }}/>
            </Link>
          </TextTooltip>
        </Stack>))}

    </Stack>);
};

export default CostBreakdownDescr;
